// extracted by css-extract-rspack-plugin
export default {"overlay":"CodingAssistantButton-module__overlay__u6Uc0","divider":"CodingAssistantButton-module__divider__hKjcG"};